import { Editor } from "@tinymce/tinymce-react";
import { UPLOAD_FILES_URL } from "constant";

export default function TinyEditor(props: { content: any; onChange?: (content: any) => void; height?: number }) {
  // const editorRef = useRef<any>(null);
  // const log = () => {
  //   if (editorRef.current) {
  //     console.log((editorRef.current as any)?.getContent());
  //   }
  // };

  const handleImageUpload = (blobInfo: any, progress: any, failure: any) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", UPLOAD_FILES_URL, true);

      const formData = new FormData();
      formData.append("file", blobInfo.blob(), blobInfo.filename());
      //console.log(blobInfo.filename())

      xhr.upload.onprogress = (e) => {
        progress((e.loaded / e.total) * 100);
        if (progress && typeof progress === "function") {
          const percent = 0;
          progress(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status === 403) {
          reject({ message: "HTTP Error: " + xhr.status, remove: true });
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          reject("HTTP Error: " + xhr.status);
          return;
        }

        const json = JSON.parse(xhr.responseText);

        json["location"] = json?.data[0]?.url;

        if (!json || typeof json.location != "string") {
          reject("Invalid JSON: " + xhr.responseText);
          return;
        }

        resolve(json.location);
      };

      xhr.onerror = () => {
        reject({ message: "Image upload failed", remove: true });
        if (failure && typeof failure === "function") {
          failure("Image upload failed");
        }
      };

      xhr.send(formData);
    });
  };

  // const [wysiwyg, setWysiwyg] = useState<string | null>(null);

  const handleEditorChange = (content: any) => {
    // setWysiwyg(content);

    props.onChange && props.onChange(content);
  };

  return (
    <>
      {/* <div className="wysiwyg">{ReactHtmlParser(wysiwyg || "")}</div> */}

      <Editor
        // initialValue={props.content}
        apiKey={process.env.REACT_APP_API_KEY_TINY_MCE || ""}
        value={props.content}
        onEditorChange={handleEditorChange}
        init={{
          height: props.height || 1000,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "code",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | styles | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
          images_upload_url: UPLOAD_FILES_URL,
          automatic_uploads: true,
          images_reuse_filename: true,
          images_upload_handler: handleImageUpload as any,
          content_style: "iframe, figure, img  { width: 100%; max-height: 70% }",
          // selector: "textarea.editor" as any,
          // setup: function (ed) {
          //   ed.on("change", function (e) {
          //     previewContent(ed.getContent());
          //   });

          //   ed.on("keyup", function (e) {
          //     previewContent(ed.getContent());
          //   });
          // },
        }}
      />
    </>
  );
}
